export default __webpack_public_path__ + "static/media/litho-demo-application.cede62e5.jpg";